var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDollar1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 287,
    viewBox: "0 0 160 287",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159.094 185.218C159.094 143.663 134.161 129.416 84.2954 123.48C48.6772 118.73 41.5536 109.233 41.5536 92.6089C41.5536 75.9849 53.4273 65.3021 77.1718 65.3021C98.5427 65.3021 110.416 72.4259 116.352 90.2353C117.54 93.7971 121.102 96.1708 124.664 96.1708H143.658C148.408 96.1708 151.97 92.6089 151.97 87.8616V86.6734C147.22 60.552 125.849 40.3689 98.5427 37.9953V9.50025C98.5427 4.75012 94.9809 1.18824 89.0455 0H71.2364C66.4863 0 62.9245 3.56188 61.7363 9.50025V36.8071C26.1181 41.5572 3.56182 65.3021 3.56182 94.9854C3.56182 134.166 27.3063 149.599 77.1718 155.537C110.416 161.473 121.102 168.597 121.102 187.594C121.102 206.592 104.478 219.651 81.9218 219.651C51.0508 219.651 40.3654 206.589 36.8036 188.78C35.6182 184.032 32.0564 181.656 28.4945 181.656H8.30902C3.56183 181.656 0 185.218 0 189.968V191.156C4.74719 220.837 23.7445 242.208 62.9245 248.146V276.641C62.9245 281.389 66.4863 284.95 72.4218 286.139H90.2308C94.9809 286.139 98.5427 282.577 99.7309 276.641V248.146C135.349 242.208 159.094 217.275 159.094 185.218V185.218Z",
    fill: "#212121",
    fillOpacity: 0.87
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar1);
export default __webpack_public_path__ + "static/media/dollar1.711a879a.svg";
export { ForwardRef as ReactComponent };